import { Fragment, type ReactNode } from "react";

type Props<T> = {
  headers: string[] | string[][] | ReactNode[];
  values: T[][];
  headersClasses?: string;
  valuesClasses?: string;
  outerContainerClasses?: string;
};

const KeyValuesGrid = <T extends React.ReactNode>({
  headers,
  values,
  headersClasses,
  valuesClasses,
  outerContainerClasses,
}: Props<T>) => {
  return (
    <div
      className={`flex flex-1 rounded-md border border-neutral-500 bg-white p-6 text-base text-neutral-100 shadow-light ${
        outerContainerClasses ?? ""
      }`}
    >
      <div className={`flex flex-col ${headersClasses}`}>
        {headers.map((item, i) => (
          <Fragment key={i}>
            <div
              key={i}
              className={`w-full p-4 font-medium ${!item ? "py-7 after:-top-[1px]" : ""}`}
            >
              {item}
            </div>
            {i !== headers.length - 1 ? (
              <div className="h-[1px] w-[calc(100%-6px)] bg-neutral-500 pr-2"></div>
            ) : null}
          </Fragment>
        ))}
      </div>

      {values.map((valuesArr, i) => (
        <div key={i} className={`flex flex-col ${valuesClasses}`}>
          {valuesArr?.map((item, i) => (
            <Fragment key={i}>
              <div
                className={`relative p-4 after:absolute after:bottom-0 after:left-0 after:top-1 after:h-[calc(100%-0.5rem)] after:w-[1px] after:bg-neutral-500 ${
                  !item ? "py-7 after:-top-[1px]" : ""
                }`}
              >
                {item?.toString()?.length ? item : ""}
              </div>
              {i !== valuesArr?.length - 1 ? (
                <div className="relative left-[6px] h-[1px] w-[calc(100%-12px)] bg-neutral-500 px-2 last:h-0"></div>
              ) : null}
            </Fragment>
          ))}
        </div>
      ))}
    </div>
  );
};

export default KeyValuesGrid;
